<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="800">
      <v-form ref="FieldOffForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Field Officer</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Name"
                    :rules="[formRules.required]"
                    v-model="name"
                    variant="outlined"
                    density="compact"
                    :color="$vuetify.theme.themes.light.inputColor"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Office/Department"
                    :rules="[formRules.required]"
                    v-model="dept"
                    variant="outlined"
                    density="compact"
                    :color="$vuetify.theme.themes.light.inputColor"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    density="compact"
                    label="Select Intern"
                    v-model="intern_to_manage"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    multiple
                    item-value="id"
                    item-title="name"
                    closable-chips
                    chips
                    :items="internlist"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Email"
                    :rules="[formRules.required, formRules.email]"
                    v-model="email"
                    variant="outlined"
                    density="compact"
                    :color="$vuetify.theme.themes.light.inputColor"
                  />
                </v-col>
                <v-col cols="12" v-if="action == 'Add'">
                  <v-text-field
                    v-model="pass"
                    :rules="[formRules.required, formRules.password]"
                    label="Password"
                    :color="$vuetify.theme.themes.light.inputColor"
                    :type="showPassword ? 'text' : 'password'"
                    :append-inner-icon="
                      showPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    @click:append-inner="showPassword = !showPassword"
                    variant="outlined"
                    density="compact"
                  />
                </v-col>
                <v-col
                  cols="12"
                  v-if="action == 'Update' && !reupload && hasEsig"
                >
                  <v-btn
                    :color="$vuetify.theme.themes.light.submitBtns"
                    class="white--text"
                    density="comfortable"
                    variant="flat"
                    @click="reupload = !reupload"
                  >
                    <v-icon>mdi-upload</v-icon> Reupload File
                  </v-btn>
                </v-col>
                <v-col cols="12" v-if="showFileUpload">
                  <div>Upload E-sign</div>
                  <v-file-upload
                    :rules="[formRules.required]"
                    accept="image/png"
                    v-model="esig_file"
                    density="comfortable"
                    scrim="primary"
                  ></v-file-upload>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4" v-if="action != 'View'">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              {{ action == "Add" ? "Add" : "Update" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      showPassword: false,
      btnLoading: false,
      name: null,
      dept: null,
      email: null,
      pass: null,
      intern_to_manage: [],
      internlist: [],
      esig_file: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      reupload: false,
      hasEsig: false,
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        // this.initialize();
        this.loadInterns();
        this.$refs.FieldOffForm.resetValidation();
        console.log(data);
        if (data.id) {
          this.name = data.officer_name;
          this.dept = data.dept;
          this.email = data.email;
          this.hasEsig = data.esig_filename ? true : false;
        } else {
          this.$refs.FieldOffForm.reset();
        }
      },
      deep: true,
    },
  },

  computed: {
    showFileUpload() {
      let show = false;
      if (this.action == "Update") {
        if (this.hasEsig) {
          if (this.reupload) {
            show = true;
          }
        } else {
          show = true;
        }
      }
      if (this.action == "Add") {
        show = true;
      }
      return show;
    },
    getStudentHandled() {
      let handled = [];
      if (this.data) {
        if (this.data.handled_interns[0].length > 0) {
          for (let i = 0; i < this.data.handled_interns[0].length; i++) {
            handled.push(this.data.handled_interns[0][i].student.id);
          }
        }
      }
      return handled;
    },
  },
  methods: {
    loadInterns() {
      let url;
      if (this.action == "Add") {
        url = "/organization/loadMyInternsToDistribute";
      } else {
        url =
          "/organization/loadMyInternsToDistributeForUpdate/" + this.data.id;
      }
      this.axiosCall(url, "GET").then((res) => {
        console.log("TO DIST", res.data);
        this.internlist = res.data;
        if (this.action != "Add") {
          console.log("CALLED", this.getStudentHandled);
          this.intern_to_manage = this.getStudentHandled;
        }
      });
    },

    async save() {
      this.btnLoading = true;
      let validate = await this.$refs.FieldOffForm.validate();
      if (validate.valid) {
        if (!this.esig_file) {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message =
            "Please upload E-signature for student evaluation purposes.";
        } else {
          let data = {
            officer_name: this.name,
            dept: this.dept,
            email: this.email,
            pass: this.pass,
            intern_to_manage: JSON.stringify(this.intern_to_manage),
          };
          let fd = new FormData();
          fd.append("data", JSON.stringify(data));
          fd.append("file", this.esig_file);

          this.axiosCall("/organization/add-field-officer", "POST", fd).then(
            (res) => {
              if (res.data.status == 201) {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;

                this.closeD();
              } else if (res.data.status == 400) {
                this.btnLoading = false;
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              }
            },
          );
        }
      } else {
        this.btnLoading = false;
      }
    },

    async update() {
      this.btnLoading = true;
      let validate = await this.$refs.FieldOffForm.validate();
      if (validate.valid) {
        let data = {
          id: this.data.id,
          officer_name: this.name,
          dept: this.dept,
          intern_to_manage: JSON.stringify(this.intern_to_manage),
        };

        this.axiosCall("/organization/update-field-officer", "POST", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;

              this.closeD();
            } else if (res.data.status == 400) {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          },
        );
      } else {
        this.btnLoading = false;
      }
    },

    closeD() {
      eventBus.emit("closeFieldOfficerDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
